import React from 'react';

import * as S from './ReviewAndRatings.styles';
import TripAdvisorIcon from '../../../../../stories/Icons/TripAdvisorIcon';

import {getRatingsColor, getStarRatingColor} from '@stencil/hotels-utils/src/get-ratings-colors';

const taTextMapping = {
  '5': 'Excellent',
  '4': 'Very Good',
  '3': 'Average',
  '2': 'Poor',
  '1': 'Bad',
};

const ReviewAndRatings = ({
  hotelReview,
  ratingCount,
  reviewCount,
  ratingType = 0,
  breakup = [],
  isHotelCard = true,
}) => {
  const isTA = ratingType === 3;
  const displayAggregateSeoAttributes = isHotelCard && reviewCount && hotelReview;
  return (
    <S.ReviewAndRatingOuterContainer
      itemProp={displayAggregateSeoAttributes ? 'aggregateRating' : undefined}
      itemScope={displayAggregateSeoAttributes ? true : undefined}
      itemType={displayAggregateSeoAttributes ? 'http://schema.org/AggregateRating' : undefined}
    >
      <S.HotelTotalReviewWrapper>
        {/* {(reviewCount && (
          <S.TotalReviewCountText
            itemProp={isHotelCard && reviewCount ? 'reviewCount' : undefined}
            content={reviewCount}
          >
            {reviewCount} Reviews
          </S.TotalReviewCountText>
        )) ||
          null} */}
        {(ratingCount && (
          <S.TotalReviewCountText
            itemProp={isHotelCard && ratingCount ? 'ratingCount' : undefined}
            content={ratingCount}
          >
            {ratingCount} Ratings
          </S.TotalReviewCountText>
        )) ||
          null}
        {(hotelReview && (
          <S.AverageReviewWrapper bgColor={getRatingsColor(hotelReview, isTA)}>
            {ratingType && isTA && <TripAdvisorIcon />}
            <S.AverageReviewText
              itemProp={isHotelCard && hotelReview ? 'ratingValue' : undefined}
              content={hotelReview}
            >
              {hotelReview} / 5
            </S.AverageReviewText>
          </S.AverageReviewWrapper>
        )) ||
          null}
        {(breakup && breakup.length > 0 && (
          <S.GuestReviewPopUpWrap>
            <S.GoRatingBlock bgColor={getRatingsColor(hotelReview, isTA)}>
              <S.AvgReviewTextWrapperDiv>
                <S.AvgReviewTextWrapper>{hotelReview}</S.AvgReviewTextWrapper>
                <S.TotalReviewTextWrapper>/5</S.TotalReviewTextWrapper>
              </S.AvgReviewTextWrapperDiv>
              {reviewCount && (
                <S.ReviewCountTextWrapper>{reviewCount} Reviews</S.ReviewCountTextWrapper>
              )}
              <S.RatingsCountTextWrapper>{ratingCount} Ratings</S.RatingsCountTextWrapper>
            </S.GoRatingBlock>
            <S.BreakupWrapperDiv>
              {breakup.map((_, index) => {
                const item = breakup[5 - index - 1];
                let calculatedWidth = (item * 1.5) / 100;
                calculatedWidth = calculatedWidth > 7 ? 7 : calculatedWidth;
                return (
                  <S.BreakupWrapperContainer>
                    <S.ReviewTypeTextWrapper>
                      {/* {isTA ? taTextMapping[5 - index] : 5 - index} */}
                      {5 - index}
                    </S.ReviewTypeTextWrapper>
                    <S.StarDiv />
                    <S.ProgressBarWrapperDiv>
                      <S.OverriddenProgressBar>
                        <S.ProgressLine
                          width={calculatedWidth}
                          bgColor={getStarRatingColor(5 - index, isTA)}
                        />
                      </S.OverriddenProgressBar>
                    </S.ProgressBarWrapperDiv>
                    <S.ProgressBarCountWrapper>{item}</S.ProgressBarCountWrapper>
                  </S.BreakupWrapperContainer>
                );
              })}
            </S.BreakupWrapperDiv>

            <S.TipPositioning />
          </S.GuestReviewPopUpWrap>
        )) ||
          null}
      </S.HotelTotalReviewWrapper>
    </S.ReviewAndRatingOuterContainer>
  );
};

export default ReviewAndRatings;
